import { type JoinEvent, createJoinEvent } from 'models';
import { useMutation } from 'query';

import { joinEvent } from '../services';

export const useEnterBigMarker = () =>
  useMutation<JoinEvent, { email?: string; eventId: string; exitUrl?: string; userIds: string[] }>({
    async mutationFn({ email, eventId, exitUrl, userIds }) {
      const response = await joinEvent({ email, eventId, exitUrl, userIds });

      return createJoinEvent(response.data);
    },
  });
